import { apiSlice } from "./apiSlice";

export const projectStatus = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getLastUpdatedOnStatus: builder.query({
            query: ({ ProjectId }) => ({
                 url: `ProjectStatus?projectId=${ProjectId}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    }),
});

export const { useGetLastUpdatedOnStatusQuery } = projectStatus;